module.exports = __webpack_public_path__ + "media/images/flags/pr-86f52f9a59e67e2a8452ed1865ae86b4.svg";